import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { RolesPermissions } from '@connect-x-app/shared-domain-models';
import { Spinner } from '@connect-x-app/web-ui';

import { TabRouter } from '../../../shared';
import { Tab } from '../../../shared/tabRouter/TabRouter';
import { useRole } from './hooks/useRole';
import { RoleDetails } from './tabs/roleDetails/RoleDetails';
import { RolePermissions } from './tabs/rolePermissions/RolePermissions';
import { RoleQuickReplies } from './tabs/roleQuickReplies/RoleQuickReplies';

export const Role: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { data, isError, isLoading, updateBreadCrumbsName } = useRole();

  useEffect(() => {
    updateBreadCrumbsName();
  }, [location, updateBreadCrumbsName]);

  if (isLoading) {
    return <Spinner>{t('SHARED.LOADING_APPLICATION')}</Spinner>;
  }

  if (isError) {
    return <Navigate to="/admin/connect/roles" />;
  }

  const tabs: Tab[] = [
    {
      label: t('TAB.ROLES.ROLE.DETAILS'),
      name: 'Roles',
      order: 0,
      permissions: [RolesPermissions.VIEW, RolesPermissions.UPDATE],
      url: `/admin/connect/roles/${data?.id}/details`,
    },
    {
      label: t('TAB.ROLES.ROLE.PERMISSIONS'),
      name: 'Permissions',
      order: 1,
      permissions: [RolesPermissions.UPDATE, RolesPermissions.VIEW],
      url: `/admin/connect/roles/${data?.id}/permissions`,
    },
    {
      label: t('QUICK_REPLIES.LABEL_other'),
      name: 'quickReplies',
      order: 2,
      permissions: [RolesPermissions.UPDATE, RolesPermissions.VIEW],
      url: `/admin/connect/roles/${data?.id}/quick-replies`,
    },
  ];

  return data ? (
    <>
      <TabRouter navBarClassName="top-nav-bar" tabs={tabs} textSize="XL" />
      <Routes>
        <Route element={<Navigate replace to="details" />} index />
        <Route element={<RoleDetails data={data} isLoadingRole={isLoading} />} path="details" />
        <Route element={<RolePermissions />} path="permissions" />
        <Route element={<RoleQuickReplies />} path="quick-replies" />
        <Route element={<Navigate to={`/admin/connect/roles/${data.id}/details`} />} path="*" />
      </Routes>
    </>
  ) : (
    <></>
  );
};
